import * as React from 'react'
import cx from 'classnames'
import { observer } from 'mobx-react'
import styles from './TypingIndicator.sass'
import ConversationViewModel from '../ConversationViewModel'

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  vm: ConversationViewModel
}

export default observer(function TypingIndicator({ vm }: Props) {
  return (
    <div className={cx(styles.root)}>
      <div className={styles.typing}>
        {vm.peopleCurrentlyTyping.length > 4 ? (
          'Several people are typing.'
        ) : (
          <SpecificTypingIndicator vm={vm} />
        )}
      </div>
    </div>
  )
})

function SpecificTypingIndicator({ vm }: { vm: ConversationViewModel }) {
  if (vm.peopleCurrentlyTyping.length === 0) {
    return null
  }
  const last = vm.peopleCurrentlyTyping.slice(-1)[0]
  const rest = vm.peopleCurrentlyTyping.slice(0, -1)
  return (
    <>
      {rest.length > 0 && (
        <>
          {rest.map((name, i) => (
            <>
              <span className={styles.name}>{name}</span>
              {i < rest.length - 1 && <>, </>}
            </>
          ))}
          {' and '}
        </>
      )}
      {last && <span className={styles.name}>{last}</span>}{' '}
      {rest.length > 0 ? 'are' : 'is'} typing
    </>
  )
}
